import React from 'react'
import { NavLink } from 'react-router-dom'
import './header.css'

const HeaderElement = () => (
    <div className="header">
        <div className="header_content">
            <NavLink to="/">
                <img src="/images/logo/logo_header2.png" width="40px" alt="matterflies_logo" />
                <img src="/images/logo/logo_header.png" width="140px" alt="matterflies_logo2" />
            </NavLink>
        </div>
    </div>
)

export { HeaderElement }
